const OPTIONS = [["confirmed", "confirmed"], ["no_show", "no-show"]];

export const Attendance = ({ s, onStatus, onAttended }) => (
  <div className="attend" data-testid={`attendance-${s.id}`}>
    {s.invite_run && <span className="attend-run" data-testid={`invite-run-${s.id}`}>{s.invite_run.when} · {s.invite_run.where}</span>}
    <div className="attend-btns" role="group" aria-label="attendance">
      {OPTIONS.map(([v, label]) => {
        const on = s.status === v;
        return (
          <button key={v} type="button" aria-pressed={on} className={`attend-btn ${v} ${on ? "on" : ""}`}
            onClick={() => onStatus(on ? "invited" : v)} data-testid={`mark-${v}-${s.id}`}>
            {label}
          </button>
        );
      })}
      {s.status === "confirmed" && (
        <button type="button" className="attend-btn ran" onClick={onAttended} data-testid={`mark-attended-${s.id}`}>
          showed up ✓
        </button>
      )}
    </div>
  </div>
);
